import { addTranslations } from "../../../translations/language-provider/translations";
// todo - remove everything that comes from outside the lib folder(manage somehow)

const messages = {
  contentManagement: "Gestion des Contenus",
  emailTemplates: "Modèles d'email",
  customTexts: "Textes Personnalisés",
  pacients: "Patients",
  prescribers: "Prescripteurs",
  companies: "Entreprises",
  questionnairesMenu: "Questionnaires",
  questionsMenu: "Questions",
  usersMenu: "Utilisateurs",
  otherMenu: "Autres",
  answersMenu: "Réponses",
  answerQuestionnaireMenu: "Répondre au questionnaire",
  new: "Nouveau",
  criteriaMenu: "Critères",
  criteriaUsageMenu: "Imputations",
  metaSkillMenu: "Méta compétences",
  principleMenu: "Principes",
  algorithmMenu: "Algorithme Principal",
  invitesMenu: "Invitation",
  elementMenu: "Éléments",
  feelingsMenu: "Sentiments",
  organsMenu: "Organes",
  outputMenu: "Outputs",
  attributesMenu: "Attributs",
  inputMenu: "Entrées",
  secondaryAlgorithmMenu: "Algorithme Secondaire",
  naturalElementMenu: "Éléments Naturels",
  seasonMenu: "Saisons",
  characterMenu: "Caractéres",
  answerComponentMenu: "Composants",
  mobileApkMenu: "Applications Mobile",
  criteriaManagementMenu: "Gestion des Critères",
  apkMenu: "APK",
  textConfigMenu: "Config Texte",
  algorithmOutputMenu: "Output d'Algorithme",
  generalOutputMenu: "Output Générale",
  highlightMenu: "Highlights",
  highlightTypeMenu: "Highlight Types",
  highlightOutputMenu: "Outputs",
  dailyChallengeMenu: "Challenge Quotidien",
  staticStringMenu: "Strings Statiques",
  userBackofficeMenu: "Utilisateurs Backoffice",
  companyUsersMenu: "Utilisateurs d'entreprise",
  userAppMenu: "Utilisateurs de APP",
  analysis: "Analyses",
  editableValues: "Valeurs éditables",
  settingsMenu: "Paramètres",
  configurationMenu: "Configuration",
  advancedMenu: "Avancé",
  welcome: "Bienvenue",
  welcome_back_name: "Bon retour, {name}",
  welcome_subtitle:
    "Voici un aperçu des 30 derniers jours et des raccourcis vers les tâches courantes.",
  metrics_last_30_days: "30 derniers jours",
  analyses: "Analyses",
  completed_of: "{completed} terminées sur {total}",
  invitations_sent: "Invitations envoyées",
  reports_sent: "Rapports envoyés",
  new_patients: "Nouveaux patients",
  new_prescribers: "Nouveaux prescripteurs",
  quick_access: "Accès rapide",
  reports: "Rapports",
  search_placeholder: "Rechercher patients, analyses, pages…",
  search_pages: "Pages",
  search_patients: "Patients",
  search_prescribers: "Prescripteurs",
  search_analyses: "Analyses",
  search_invitations: "Invitations",
  search_no_results: "Aucun résultat trouvé",
  page_desc_welcome: "Aperçu et indicateurs clés des 30 derniers jours",
  page_desc_history: "Voir et gérer les analyses récentes et leur statut",
  page_desc_questionnaire:
    "Démarrer une analyse, créer des invitations ou prépayer un questionnaire",
  page_desc_invites: "Parcourir les invitations et renvoyer les emails",
  page_desc_pacients: "Voir et gérer les comptes patients",
  page_desc_prescribers: "Voir et gérer les comptes prescripteurs",
  page_desc_companies: "Voir et gérer les entreprises, les frais de plateforme et le statut Stripe",
  page_desc_users_backoffice:
    "Gérer les admins et consultants avec accès backoffice",
  page_desc_users_app: "Gérer les utilisateurs avec accès à l'application mobile",
  page_desc_reports: "Modifier le contenu, les textes et options des rapports",
  page_desc_email_templates: "Gérer les modèles de contenu email",
  page_desc_custom_texts: "Gérer les textes personnalisés du système",
  page_desc_push_notifications: "Gérer le contenu des notifications push",
  page_desc_settings: "Configurer les constantes et valeurs éditables du système",
  page_desc_questionnaires: "Créer et gérer les questionnaires",
  page_desc_questions: "Créer et gérer les questions",
  page_desc_answer_options: "Créer et gérer les options de réponse",
  page_desc_gallery: "Parcourir et téléverser les images de la galerie",
  page_desc_criteria: "Gérer les critères de l'algorithme",
  page_desc_criteria_usage: "Gérer l'utilisation des critères dans l'algorithme",
  page_desc_meta_skill: "Gérer les méta compétences",
  page_desc_principle: "Gérer les principes",
  page_desc_algorithm_config: "Configurer les paramètres de l'algorithme",
  page_desc_element: "Gérer les éléments de l'algorithme",
  page_desc_feeling: "Gérer les attributs de sentiments",
  page_desc_organ: "Gérer les attributs d'organes",
  page_desc_season: "Gérer les attributs de saisons",
  page_desc_natural_element: "Gérer les attributs d'éléments naturels",
  page_desc_character: "Gérer les attributs de caractères",
  page_desc_input: "Gérer les entrées de l'algorithme",
  page_desc_algorithm_output: "Gérer les outputs d'algorithme",
  page_desc_general_output: "Gérer les outputs généraux",
  page_desc_mobile_apps: "Gérer les applications mobiles",
  page_desc_criteria_management: "Gérer les paramètres de gestion des critères",
  prescriber_dashboard: "Mon Tableau de Bord",
  page_desc_prescriber_dashboard:
    "Prescrire des analyses et suivre vos propres invitations, comme dans le backoffice",
};

addTranslations("fr-FR", messages);

export default messages;
